import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {Checkbox} from 'shells/checkbox/checkbox';

type Props = FieldProps;

export function IgnoreField(props: Props) {
    return (
        <Checkbox
            checked={props.input.value}
            isLarge={true}
            label='Don’t save data from this field'
            onChange={() => props.input.onChange(!props.input.value)}
        />
    );
}
